import angular from 'angular';

class DropdownManager {

    constructor() {
        document.removeEventListener('click', this.onClickDropdownHandler.bind(this));
        document.addEventListener('click', this.onClickDropdownHandler.bind(this));
    }

    addClassesIsActive(button) {
        button.setAttribute('data-is-active', 1);
        button.className += ' ' + button.getAttribute('data-is-active-class');
        var dropdownIsActiveClass;

        if (dropdownIsActiveClass = button.getAttribute('data-dropdown-is-active-class')) {
            var dropdown = document.getElementById(button.getAttribute('data-dropdown-id'));
            dropdown.className += ' ' + dropdownIsActiveClass;
        }
    }

    removeClassesIsActive(button) {
        button.setAttribute('data-is-active', 0);
        button.className = button.className.replace(button.getAttribute('data-is-active-class'), '').trim();
        var dropdownIsActiveClass;

        if (dropdownIsActiveClass = button.getAttribute('data-dropdown-is-active-class')) {
            var dropdown = document.getElementById(button.getAttribute('data-dropdown-id'));
            dropdown.className = dropdown.className.replace(dropdownIsActiveClass, '').trim();
        }
    }

    onClickDropdownHandler(event) {
        var buttons = document.getElementsByClassName('js-dropdown-button');
        for (var i = 0; i < buttons.length; i++) {
            var button = buttons[i];
            if (button.getAttribute('data-is-active') == 1) {
                var dropdown = document.getElementById(button.getAttribute('data-dropdown-id'));
                var isClickInside = dropdown.contains(event.target);
                var excludedElement = false;

                if (button.getAttribute('data-excluded-dropdown-element')) {
                    excludedElement = document.getElementById(button.getAttribute('data-excluded-dropdown-element'));
                }

                if (button.contains(event.target) || !isClickInside ||
                    (excludedElement && excludedElement.contains(event.target))
                ) {
                    this.removeClassesIsActive(button);
                }
            } else if (button.contains(event.target)) {
                this.addClassesIsActive(button);
            }
        }
    }

}

const module = angular.module('st.services.dropdown', [])
    .service('DropdownManager', DropdownManager)
    .name;

export default module;



// WEBPACK FOOTER //
// ./client/app/services/dropdown.service.js